import React from 'react';

import compensation from '../../../images/compensation.svg';

import { FOHImage } from '../../ingredients';

export const FOHCompensationIcon = (props: any) => (
  <FOHImage
    source={{ uri: compensation }}
    style={
      props && !!props.style
        ? { width: 24, height: 24, ...props.style }
        : { width: 24, height: 24 }
    }
  />
);
